export default __webpack_public_path__ + "images/SSJ.ef2b66b.png";